import React from 'react';

import styles from '../../TaskTypeField.module.scss';

export default function EventFieldLayoutWeb() {
  const classes = [
    styles.field,
    styles.event,
  ];

  return (
    <div className={classes.join(' ')} title="Event task">&nbsp;</div>
  );
}
